import { Icon } from '@zambezi/sdk/icons';
import classNames from 'classnames';
import React from 'react';
import ScreenReaderOnly from '../ScreenReaderOnly';
import './IconButton.scss';

type ButtonType = 'button' | 'submit' | 'reset';
export interface IconButtonProps {
  iconProps: React.ComponentProps<typeof Icon>;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  children: string;
  className?: string;
  type?: ButtonType;
  disabled?: boolean;
  isLoading?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({
  type = 'button',
  iconProps,
  disabled,
  isLoading,
  className,
  children,
  ...rest
}) => {
  const classes = classNames('zb-button mss-icon-button', className, {
    'zb-button-is-disabled': disabled,
    'zb-button-is-loading': isLoading
  });
  return (
    <button className={classes} type={type} disabled={disabled || isLoading} {...rest}>
      <ScreenReaderOnly>{children}</ScreenReaderOnly>
      <Icon {...iconProps} />
    </button>
  );
};

export default IconButton;
